export default __webpack_public_path__ + "static/media/payment-waiting.30547a8b.svg";